import { config } from './config.js';

// Union-node anchor preservation for Canvas's live-drag geometry updates.
//
// The layout engine does NOT always place a union at the plain midpoint of its
// partners: an asym-parked junction sits clamped toward one partner (in-law
// tower over-child, crossingRefine), a multi-spouse staircase union carries a
// per-spouse offset, and a lane-routed union sits on its lane below the row.
// Canvas's drag handlers historically recomputed union positions as the naive
// `(p1.x + p2.x) / 2`, silently discarding those engine anchors — which is why
// a plain CLICK (a zero-move d3 drag) visibly snapped the 12-13 → 9 connector
// to the midpoint in G-1-01422 (Theme B of
// claude-MDs/PLAN-pedigree-rapid-add-race-and-click-rebake.md).
//
// The fix: once per settled layout, stamp each union with its OFFSET from the
// partners' midpoint (the engine's anchor, whatever pass produced it). Any
// later live refresh re-applies midpoint + offset — exact for translations
// (group drags, snap-backs), and a plain midpoint union (offset 0) behaves
// exactly as before.

export function stampUnionAnchors(nodesById) {
  if (!nodesById || typeof nodesById.forEach !== 'function') return;
  nodesById.forEach((n) => {
    if (n.kind !== config.NODE_TYPE.UNION) return;
    const p1 = nodesById.get(n.parent1Id);
    const p2 = nodesById.get(n.parent2Id);
    if (!p1 || !p2) return;
    n.anchorDx = n.x - (p1.x + p2.x) / 2;
    n.anchorDy = n.y - (p1.y + p2.y) / 2;
  });
}

// Where a union belongs given its partners' CURRENT positions: the midpoint
// plus the engine anchor stamped at layout time (0 when never stamped).
export function unionRefreshPosition(n, p1, p2) {
  return {
    x: (p1.x + p2.x) / 2 + (n.anchorDx || 0),
    y: (p1.y + p2.y) / 2 + (n.anchorDy || 0)
  };
}
